export const SOCKET_URL = "http://192.168.1.222:8000";
export const BACKEND_BASE_URL = "http://192.168.1.222:8000/";
